import React from 'react';

import { Flex, FormField, FormHelp, Label, Paragraph } from '@zillow/constellation';
import { NumberStepper } from '@zillow/zrs-comet';

import type { Section } from '../../../models/index';
import { MAXIMUM_NUMBER_OF_OCCUPANTS } from '../../../constants/index';

type Props = {
  section: Section;
  setSectionValues: (keyValuePairs: object) => void;
};

const MAX_OCCUPANTS = 99;
const MAX_COMMON_AREA_PEOPLE = 99;

function MaximumNumberOfOccupants_v2({ section, setSectionValues }: Props) {
  function onMaximumOccupancyChange(value: number): void {
    setSectionValues({
      [MAXIMUM_NUMBER_OF_OCCUPANTS.FIELD_NAME.MAXIMUM_NUMBER_OF_OCCUPANTS]: value,
    });
  }
  function onMaximumCommonAreaPeopleChange(value: number): void {
    setSectionValues({
      [MAXIMUM_NUMBER_OF_OCCUPANTS.FIELD_NAME.MAXIMUM_NUMBER_OF_PEOPLE_COMMON_AREA]: value,
    });
  }

  const maximumOccupants = Number(
    section.getFieldValue(MAXIMUM_NUMBER_OF_OCCUPANTS.FIELD_NAME.MAXIMUM_NUMBER_OF_OCCUPANTS),
  );
  const maximumCommonAreaPeople = Number(
    section.getFieldValue(MAXIMUM_NUMBER_OF_OCCUPANTS.FIELD_NAME.MAXIMUM_NUMBER_OF_PEOPLE_COMMON_AREA),
  );

  return (
    <>
      <FormField
        label={<Label size="lg">What is the maximum number of persons permitted in the rental unit at any time?</Label>}
        control={
          <Flex display="flex" alignItems="center" flexDirection="column">
            <NumberStepper min={1} max={MAX_OCCUPANTS} value={maximumOccupants} onChange={onMaximumOccupancyChange} />
            <Paragraph>total people allowed</Paragraph>
          </Flex>
        }
        description={
          maximumOccupants === MAX_OCCUPANTS && (
            <Flex display="flex" alignItems="center" flexDirection="column">
              <FormHelp>{`${MAX_OCCUPANTS} is the maximum`}</FormHelp>
            </Flex>
          )
        }
        marginBottom="sm"
      />
      <FormField
        label={
          <Label>
            What is the maximum number of people permitted within the common areas of your building at any time?
          </Label>
        }
        control={
          <Flex display="flex" alignItems="center" flexDirection="column">
            <NumberStepper
              min={1}
              max={MAX_COMMON_AREA_PEOPLE}
              value={maximumCommonAreaPeople}
              onChange={onMaximumCommonAreaPeopleChange}
            />
            <Paragraph>total people allowed</Paragraph>
          </Flex>
        }
        description={
          maximumCommonAreaPeople === MAX_COMMON_AREA_PEOPLE && (
            <Flex display="flex" alignItems="center" flexDirection="column">
              <FormHelp>{`${MAX_COMMON_AREA_PEOPLE} is the maximum`}</FormHelp>
            </Flex>
          )
        }
      />
    </>
  );
}

MaximumNumberOfOccupants_v2.description =
  'Allow Irene to set the maximum number of people within the unit and common areas';

export default MaximumNumberOfOccupants_v2;
